var map = {
	"./ALNA.svg": 365,
	"./Amaris.svg": 3338,
	"./BABE.svg": 2605,
	"./BAHA.svg": 3607,
	"./BRUN.svg": 4800,
	"./HO24.svg": 3376,
	"./HOHL.svg": 6902,
	"./HOLU.svg": 691,
	"./ILBE.svg": 1573,
	"./ILER.svg": 877,
	"./LGED.svg": 3865,
	"./LIEB.svg": 6789,
	"./LIHE.svg": 9141,
	"./LOBE.svg": 205,
	"./SAMB.svg": 5996,
	"./SAMS.svg": 6557,
	"./SOCO.svg": 2617,
	"./SOMA.svg": 5629,
	"./SSIM.svg": 4137,
	"./Tchi.svg": 3507,
	"./VAHA.svg": 4291,
	"./VANM.svg": 2389,
	"./WCPL.svg": 663,
	"./WEST.svg": 7064,
	"./WEW2.svg": 9010,
	"./WEWI.svg": 2969,
	"./WICZ.svg": 9210,
	"./WING.svg": 3088,
	"./WIPL.svg": 7709,
	"./WNCZ.svg": 8073,
	"./WWPL.svg": 9243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7467;